import { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../component css/Navbar.css";
import logo from "../assets/images/navbar/logo.svg";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showNavbar, setShowNavbar] = useState(true);
  const [scrolled, setScrolled] = useState(false);
  const pauseTimerRef = useRef(null);

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  const closeMenu = () => {
    setMenuOpen(false);
    // Only kill pinned triggers (the hero pin) — leave scroll-scrub
    // triggers like the Featured Projects carousel alive
    ScrollTrigger.getAll().forEach((t) => {
      if (t.pin) t.kill();
    });
    document.body.classList.remove("hero-pinned");
  };

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      setScrolled(currentScrollY > 50);

      if (menuOpen || document.body.classList.contains("hero-pinned")) {
        setShowNavbar(true);
        lastScrollY = currentScrollY;
        return;
      }

      if (currentScrollY <= 10) {
        setShowNavbar(true);
        clearTimeout(pauseTimerRef.current);
      } else if (currentScrollY > lastScrollY) {
        setShowNavbar(false);
        clearTimeout(pauseTimerRef.current);
        pauseTimerRef.current = setTimeout(() => {
          setShowNavbar(true);
        }, 800);
      } else {
        setShowNavbar(true);
        clearTimeout(pauseTimerRef.current);
      }

      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(pauseTimerRef.current);
    };
  }, [menuOpen]);

  return (
    <>
      <header
        className={`navbar ${showNavbar ? "show" : "hide"} ${
          scrolled ? "scrolled" : ""
        }`}
      >
        <button
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={toggleMenu}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
          type="button"
        >
          <div className="hamburger-icon">
            <span></span>
            <div className="middle-line">
              <span></span>
              <span></span>
            </div>
            <span></span>
          </div>
          <span className="menu-text">{menuOpen ? "" : "Menu"}</span>
        </button>

        <NavLink to="/" className="logo" onClick={closeMenu}>
          <img src={logo} alt="Logo" width="138" height="236" />
        </NavLink>

        <NavLink
          to="/contact"
          className="contact_link_nav"
          onClick={closeMenu}
        >
          Contact
        </NavLink>
      </header>

      <div
        className={`overlay ${menuOpen ? "show" : ""}`}
        onClick={closeMenu}
      ></div>

      <nav className={`nav-menu ${menuOpen ? "open" : ""}`}>
        <NavLink
          to="/"
          onClick={closeMenu}
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          Home
        </NavLink>

        <NavLink
          to="/about"
          onClick={closeMenu}
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          About
        </NavLink>

        <NavLink
          to="/projects"
          onClick={closeMenu}
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          Projects
        </NavLink>

        <NavLink
          to="/contact"
          onClick={closeMenu}
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          Contact
        </NavLink>
      </nav>
    </>
  );
}

export default Navbar;